import React from 'react';
export function DealFlowFooter() {
  return <footer className="bg-charcoal-dark text-slate-light pt-16 pb-8 border-t border-charcoal-light" data-id="element-157" data-mp="zy6oxcrkhzhj">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158" data-mp="26cgtzd0gf8x1">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-159" data-mp="1scflbbdy6x70">
          <div data-id="element-160" data-mp="1xcbppbqk4qn3">
            <h3 className="font-editorial text-2xl tracking-widest uppercase mb-4 text-white" data-id="element-161" data-mp="1xbsgqkivxcl7">
              Cabo Deal Flow
            </h3>
            <p className="text-sm max-w-md mb-6 font-light leading-relaxed" data-id="element-162" data-mp="1ime7rdj80x6c">
              Curated, independently analyzed real estate investment deal flow
              in Los Cabos. Data-driven. Privacy-first.
            </p>
            <p className="text-sm" data-id="element-163" data-mp="1em3sfa9jguet">
              Contact:{' '}
              <a href="mailto:deals@cabodealflow.com" className="text-gold hover:text-white transition-colors" data-id="element-164" data-mp="1emc4izxu7voy">
                deals@cabodealflow.com
              </a>
            </p>
          </div>

          <div className="md:text-right" data-id="element-165" data-mp="3eh2k6muj75ul">
            <h4 className="font-editorial text-lg mb-4 text-white" data-id="element-166" data-mp="3eg0xfl45kux1">
              Sister Platform
            </h4>
            <p className="text-sm mb-4" data-id="element-167" data-mp="39klkcvdyz31o">
              Looking for lifestyle real estate and vetted professionals?
            </p>
            <a href="/" className="inline-block border border-slate-light px-6 py-2 text-xs uppercase tracking-widest hover:border-gold hover:text-gold transition-colors" data-id="element-168" data-mp="3jgyd9r1oxcvd">
              Visit CaboCollection.com
            </a>
          </div>
        </div>

        <div className="border-t border-charcoal pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-slate" data-id="element-169" data-mp="34j5yj13ywsi8">
          <p className="mb-4 md:mb-0 max-w-2xl" data-id="element-170" data-mp="2zrmuzbanf8h0">
            Disclaimer: This is not financial advice. All investment decisions
            should be made with your own due diligence. Projections are
            estimates based on current market data and are not guaranteed.
          </p>
          <p className="shrink-0" data-id="element-171" data-mp="b1no5d5kwj0d">
            &copy; {new Date().getFullYear()} Cabo Deal Flow.
          </p>
        </div>
      </div>
    </footer>;
}